import {
  EntityItemType as EntityType,
  ProductContentUtilizationRecord,
  VideoMetadata
} from 'src/components/BeaconRedesignComponents/ExperimentalLayout/ContentV2/ContentServerProxy/types';
import {
  getDurationString,
  getRatioString,
  getResolutionString
} from 'src/components/BeaconRedesignComponents/ExperimentalLayout/ContentV2/Summary/Visualizations/adapters/ProductContentAccuracyAdapter';
import {
  ChartDataAdapter,
  UtilizationData
} from 'src/components/BeaconRedesignComponents/ExperimentalLayout/ContentV2/Summary/Visualizations/adapters/types';

const mockApiData: ProductContentUtilizationRecord[] = [
  {
    entityType: EntityType.BulletPoint,
    entityValue: null,
    entityMetadata: null,
    metrics: {
      expectedCount: 5,
      actualCount: 5,
      score: 0.9
    },
    children: [
      {
        entityType: EntityType.BulletPointRecord,
        entityValue:
          'Authentic Italian Texture: Incredibly fine milling creates the perfect 00 flour for achieving quintessential leopard spots on your Neapolitan-style pizza crust, replicating authentic Italian pizzeria results in your home oven',
        entityMetadata: null,
        metrics: {
          expectedCount: 250,
          actualCount: 225,
          score: 0.9
        },
        children: null
      },
      {
        entityType: EntityType.BulletPointRecord,
        entityValue:
          "Premium Blend: Crafted from a proprietary mix of hard and soft 100% American-grown wheat, this pizza flour is expertly milled to exacting '00' standards, ensuring a perfect balance for great-tasting Neapolitan-style pizza",
        entityMetadata: null,
        metrics: {
          expectedCount: 250,
          actualCount: 221,
          score: 0.884
        },
        children: null
      },
      {
        entityType: EntityType.BulletPointRecord,
        entityValue:
          "Versatile Baking: While ideal for pizza dough, this flour's fine texture also excels in pasta making and other Italian-inspired recipes. Its versatility makes it a staple for home bakers exploring artisan bread and pastries",
        entityMetadata: null,
        metrics: {
          expectedCount: 250,
          actualCount: 223,
          score: 0.892
        },
        children: null
      },
      {
        entityType: EntityType.BulletPointRecord,
        entityValue:
          "Quality Assurance: Non-GMO Project Verified and milled from 100% American-grown wheat, this King Arthur flour upholds high standards of quality and purity, ensuring you're using the best ingredients in your homemade pizzas",
        entityMetadata: null,
        metrics: {
          expectedCount: 250,
          actualCount: 222,
          score: 0.888
        },
        children: null
      },
      {
        entityType: EntityType.BulletPointRecord,
        entityValue:
          "Trusted Brand: King Arthur Baking Company, founded in 1790, is America's oldest flour company. As a 100% Employee-Owned business, we're committed to providing the highest quality baking products and inspiring recipes for our customers",
        entityMetadata: null,
        metrics: {
          expectedCount: 250,
          actualCount: 234,
          score: 0.936
        },
        children: null
      }
    ]
  },
  {
    entityType: EntityType.Title,
    entityValue:
      'King Arthur 00 Pizza Flour: Premium Non-GMO American Wheat for Perfect Neapolitan-Style Crust - Finely Milled for Authentic Italian Pizza at Home - Ideal for Crispy, Chewy Pizzas (3 lbs)',
    entityMetadata: null,
    metrics: {
      expectedCount: 250,
      actualCount: 232,
      score: 0.93
    },
    children: null
  },
  {
    entityType: EntityType.Description,
    entityValue:
      "Discover the secret to creating authentic Neapolitan-style pizza at home with King Arthur 00 Pizza Flour. This premium flour is the key to achieving the perfect balance of crispy and chewy crust that defines true Italian pizza. Milled to exacting '00' standards from a proprietary blend of hard and soft 100% American-grown wheat, our flour is incredibly fine, allowing you to replicate the quintessential leopard spots characteristic of authentic Neapolitan pizzas, even in your home oven. The 3 lb resealable bag ensures freshness and convenience for multiple baking sessions. While primarily designed for pizza, this versatile flour also excels in pasta making and other Italian-inspired recipes, making it a must-have for any home baker looking to elevate their culinary creations. King Arthur 00 Pizza Flour is Non-GMO Project Verified, reflecting our commitment to quality and purity. As a 100% Employee-Owned Company and a founding B Corporation, King Arthur has been a trusted name in baking since 1790, offering top-quality products and inspiring recipes. To create the perfect Neapolitan-style pizza, aim for a thinner crust in the middle with a slightly puffed rim for that essential crunch. Top with tomato sauce, fresh mozzarella, basil, and a drizzle of olive oil for a classic margherita that will transport you straight to Naples. Baking tips: For best results, use a pizza stone or steel preheated in a very hot oven (as high as your oven will go, ideally 500°F or higher). Allow the dough to rest and rise properly for optimal texture and flavor. Remember, practice makes perfect when it comes to stretching and shaping your dough. With King Arthur 00 Pizza Flour, you're not just making pizza; you're crafting an authentic Italian experience in your own kitchen. Elevate your homemade pizzas and impress your family and friends with restaurant-quality results. Start your journey to pizza perfection today!",
    entityMetadata: null,
    metrics: {
      expectedCount: 2000,
      actualCount: 1925,
      score: 0.9625
    },
    children: null
  },
  {
    entityType: EntityType.Image,
    entityValue: null,
    entityMetadata: null,
    metrics: {
      expectedCount: 6,
      actualCount: 8,
      score: 1.0
    },
    children: [
      {
        entityType: EntityType.ImageRecord,
        entityValue: 'https://m.media-amazon.com/images/I/71F268K4PGL._SL1500_.jpg',
        entityMetadata: null,
        metrics: null,
        children: null
      },
      {
        entityType: EntityType.ImageRecord,
        entityValue: 'https://m.media-amazon.com/images/I/81Z0qPaH2sL._SL1500_.jpg',
        entityMetadata: null,
        metrics: null,
        children: null
      },
      {
        entityType: EntityType.ImageRecord,
        entityValue: 'https://m.media-amazon.com/images/I/61sAJN5hD+L._SL1500_.jpg',
        entityMetadata: null,
        metrics: null,
        children: null
      },
      {
        entityType: EntityType.ImageRecord,
        entityValue: 'https://m.media-amazon.com/images/I/61jxPoowPoL._SL1500_.jpg',
        entityMetadata: null,
        metrics: null,
        children: null
      },
      {
        entityType: EntityType.ImageRecord,
        entityValue: 'https://m.media-amazon.com/images/I/51iKYtmFpcL._SL1500_.jpg',
        entityMetadata: null,
        metrics: null,
        children: null
      },
      {
        entityType: EntityType.ImageRecord,
        entityValue: 'https://m.media-amazon.com/images/I/61bfIkhyr1L._SL1500_.jpg',
        entityMetadata: null,
        metrics: null,
        children: null
      },
      {
        entityType: EntityType.ImageRecord,
        entityValue: 'https://m.media-amazon.com/images/I/61+2DLfNiEL._SL1500_.jpg',
        entityMetadata: null,
        metrics: null,
        children: null
      },
      {
        entityType: EntityType.ImageRecord,
        entityValue: 'https://m.media-amazon.com/images/I/61b+kM9gbWL._SL1500_.jpg',
        entityMetadata: null,
        metrics: null,
        children: null
      }
    ]
  },
  {
    entityType: EntityType.Video,
    entityValue: null,
    entityMetadata: null,
    metrics: {
      expectedCount: 1,
      actualCount: 0,
      score: 1.0
    },
    children: [
      {
        entityType: EntityType.VideoRecord,
        entityValue:
          'https://m.media-amazon.com/images/S/vse-vms-transcoding-artifact-us-east-1-prod/94a5288e-4bab-44ae-9bf2-9d0cc468eac6/default.jobtemplate.hls.m3u8',
        entityMetadata: null,
        metrics: null,
        children: null
      }
    ]
  },
  {
    entityType: EntityType.APlusContent,
    entityValue: null,
    entityMetadata: null,
    metrics: {
      expectedCount: 1,
      actualCount: 1,
      score: 1.0
    },
    children: null
  }
];

/**
 * Creates a placeholder section for a section if the section is missing from the API response.
 *
 * @param sectionTitle - The title of the section to create a placeholder for.
 * @returns A UtilizationData object with default values based on the section type.
 */
const getPlaceholderSection = (sectionTitle: string): UtilizationData => {
  const sectionType = sectionTitle.split(' ')[0];

  switch (sectionType) {
    case 'Images':
      return { title: sectionTitle, content: [], type: 'image', currentUtilization: 0, maxUtilization: 6, score: 0 };
    case 'Video':
      return { title: sectionTitle, content: [], type: 'video', currentUtilization: 0, maxUtilization: 4, score: 0 };
    case 'Enhanced':
      return { title: sectionTitle, content: null, type: 'aPlusContent', currentUtilization: false };
    case 'Title':
    case 'Bullet':
    case 'Description':
    default:
      return {
        title: sectionTitle,
        content: `Missing required ${sectionType.toLowerCase()}.`,
        type: 'character',
        currentUtilization: 0,
        maxUtilization: 0,
        score: 0
      };
  }
};

const mapDataToSections = (data: UtilizationData[]): UtilizationData[] => {
  const groupedSections = data.reduce((acc, item) => {
    const baseType = item.title.split(' ')[0];
    if (!acc[baseType]) {
      acc[baseType] = [];
    }
    acc[baseType].push(item);
    return acc;
  }, {} as Record<string, UtilizationData[]>);

  if (groupedSections.Bullet) {
    groupedSections.Bullet.sort((a, b) => {
      const aNum = parseInt(a.title.split(' ')[1], 10);
      const bNum = parseInt(b.title.split(' ')[1], 10);
      return aNum - bNum;
    });
  }

  const orderedSections: UtilizationData[] = [];

  orderedSections.push(data.find((item) => item.title === 'Title') ?? getPlaceholderSection('Title'));

  // Add all available bullets
  const bulletSections = groupedSections.Bullet || [];
  if (bulletSections.length === 0) {
    for (let i = 1; i <= 5; i++) {
      orderedSections.push(getPlaceholderSection(`Bullet ${i}`));
    }
  } else {
    orderedSections.push(...bulletSections);
  }

  orderedSections.push(data.find((item) => item.title === 'Description') ?? getPlaceholderSection('Description'));

  ['Images', 'Video', 'Enhanced Content'].forEach((sectionTitle) => {
    orderedSections.push(data.find((item) => item.title === sectionTitle) ?? getPlaceholderSection(sectionTitle));
  });

  return orderedSections;
};

class ProductContentUtilizationRecordAdapter {
  record: ProductContentUtilizationRecord;

  constructor(record: ProductContentUtilizationRecord) {
    this.record = record;
  }

  private createBaseUtilization(title: string) {
    return {
      title,
      maxUtilization: this.record.metrics?.expectedCount || 0,
      currentUtilization: this.record.metrics?.actualCount || 0,
      score: this.record.metrics?.score || 0
    };
  }

  private transformTextContent(title: string) {
    return {
      ...this.createBaseUtilization(title),
      type: 'character' as const,
      content: this.record.entityValue || `This product has no ${title.toLowerCase()}.`
    };
  }

  private transformBulletPoints() {
    // TODO(tyan): define default max value somewhere, also determine behavior if there are more bullets than expected

    const actualBullets = this.record.children?.length || 0;

    return [...Array(actualBullets)].map((_, index) => {
      const bullet = index < actualBullets ? this.record.children?.[index] : undefined;
      return {
        title: `Bullet ${index + 1}`,
        content: bullet?.entityValue || 'Missing required bullet.',
        maxUtilization: bullet?.metrics?.expectedCount || 0,
        currentUtilization: bullet?.metrics?.actualCount || 0,
        score: bullet?.metrics?.score || 0,
        type: 'character' as const
      };
    });
  }

  private transformImages() {
    const expectedImages = this.record.metrics?.expectedCount || 6;
    const actualImages = this.record.children?.length || 0;
    const images = [...Array(Math.max(expectedImages, actualImages))].map((_, index) => {
      const image = index < actualImages ? this.record.children?.[index] : undefined;
      return image
        ? {
          url: image.entityValue || '',
          altText: `Image ${index + 1}`,
          resolution: getResolutionString(image.entityMetadata),
          ratio: getRatioString(image.entityMetadata)
        }
        : null;
    });

    return {
      ...this.createBaseUtilization('Images'),
      type: 'image' as const,
      content: images
    };
  }

  private transformVideo() {
    const expectedVideos = this.record?.metrics?.expectedCount || 1;
    const actualVideos = this.record?.children?.length || 0;

    const videos = [...Array(Math.max(expectedVideos, actualVideos))].map((_, index) => {
      const video = index < actualVideos ? this.record.children?.[index] : undefined;
      return video
        ? {
          url: video?.entityValue || '',
          resolution: getResolutionString(video.entityMetadata),
          length: getDurationString(video.entityMetadata as VideoMetadata)
        }
        : null;
    });

    return {
      ...this.createBaseUtilization('Video'),
      type: 'video' as const,
      content: videos
    };
  }

  toUtilizationData() {
    switch (this.record.entityType) {
      case EntityType.Title:
        return this.transformTextContent('Title');
      case EntityType.BulletPoint:
        return this.transformBulletPoints();
      case EntityType.Description:
        return this.transformTextContent('Description');
      case EntityType.Image:
        return this.transformImages();
      case EntityType.Video:
        return this.transformVideo();
      case EntityType.APlusContent:
        return {
          title: 'Enhanced Content',
          content: null,
          type: 'aPlusContent' as const,
          currentUtilization: this.record.metrics?.score === 1
        };
      default:
        return null;
    }
  }
}

export class ProductContentUtilizationAdapter implements ChartDataAdapter<UtilizationData[]> {
  data: ProductContentUtilizationRecord[];

  constructor(data: ProductContentUtilizationRecord[] = mockApiData) {
    this.data = data;
  }

  transform(): UtilizationData[] {
    const transformedData: UtilizationData[] = this.data

      .map((record) => {
        return new ProductContentUtilizationRecordAdapter(record).toUtilizationData();
      })
      .filter((item) => item !== null)
      .flat();

    return mapDataToSections(transformedData);
  }
}
